module.exports = __webpack_public_path__ + "static/media/ipsum_city_demo_crest.5501e9e8.jpeg";